// One definition of the filter shape, so adding a filter cannot leave "Clear all" behind
// still clearing the old set.
export const EMPTY_FILTERS = {
	status: "",
	patient: "",
	therapist: "",
	registrationNumber: "",
	invoiceNumber: "",
	city: "",
	assignedTo: "",
	serviceIds: "",
	packageIds: "",
	patientGenders: "",
	// Comma-separated because populateQueryParams writes one value per key, so a real
	// array param would collapse to its last entry. The backend splits on the comma.
	therapistEmploymentTypes: "",
	draftId: "",
	createdFrom: "",
	createdTo: "",
	visitFrom: "",
	visitTo: "",
	hasSoap: "",
	hasEvidence: "",
	visitPositions: "",
	allVisitsCompleted: "",
};

export type AppointmentFilters = typeof EMPTY_FILTERS;

// The sheet carries 18 controls, too many to read as one flat grid, so they render under
// six named headings. `controls` is a list of controls, not of params: a date range writes two
// keys but is one thing the user set, and the heading count has to say "1".
export const FILTER_GROUPS = [
	{
		key: "identity",
		controls: [["registrationNumber"], ["invoiceNumber"], ["draftId"]],
	},
	{
		key: "visit",
		controls: [
			["status"],
			["visitFrom", "visitTo"],
			["createdFrom", "createdTo"],
			["visitPositions"],
			["allVisitsCompleted"],
		],
	},
	{ key: "patient", controls: [["patient"], ["patientGenders"]] },
	{
		key: "therapist",
		controls: [["therapist"], ["therapistEmploymentTypes"], ["assignedTo"]],
	},
	{
		key: "service_region",
		controls: [["serviceIds"], ["packageIds"], ["city"]],
	},
	{ key: "documents", controls: [["hasSoap"], ["hasEvidence"]] },
] as const satisfies ReadonlyArray<{
	key: string;
	controls: ReadonlyArray<ReadonlyArray<keyof AppointmentFilters>>;
}>;

export type FilterGroupKey = (typeof FILTER_GROUPS)[number]["key"];

/** How many controls in this group the user has actually set. */
export function countActiveFilters(
	group: (typeof FILTER_GROUPS)[number],
	filters: AppointmentFilters,
): number {
	return group.controls.filter((keys) => keys.some((key) => filters[key]))
		.length;
}
